export const researchCV = {
  id: 'research-cv',
  version: 2,
  renderer: 'enterprise',
  name: 'Research & Academic CV',
  layout: 'single-column',
  theme: 'classic-navy',
  density: 'dense',
  persona: ['research'],
  atsLevel: 'A+',
  scoreWeights: {
    ats: 50,
    visual: 10,
    executive: 20,
    student: 20
  },
  metadata: {
    industry: ['Academic Research', 'Biotechnology', 'R&D'],
    companies: ['CERN', 'Max Planck Institute', 'MIT Labs', 'Pfizer R&D', 'NASA Ames', 'DeepMind'],
    ats: ['Workday', 'Taleo'],
    pages: { min: 2, max: 10, preferred: 3 },
    photo: false,
    icons: false,
    columns: 1,
    experienceLevel: ['Researcher', 'PhD Candidate', 'Postdoc', 'Professor'],
    careerStage: 'Academic',
    recommendedFor: ['Research Scientists', 'PhD Applicants', 'Postdoctoral Fellows', 'R&D Engineers'],
    avoidFor: ['Creative Directors', 'Sales Representatives', 'UI/UX Designers'],
    dna: ['Academic-Dense', 'Citations-Rich', 'Georgia-Serif', 'Traditional', 'Multi-Page'],
    metrics: {
      readingDifficulty: 99,
      scanningSpeed: 90,
      visualAppeal: 78
    },
    hiringManager: {
      firstImpression: "Highly academic, thorough, credentialed research specialist",
      scanningStyle: "Linear scanning focusing on publications, patents, citation records, and grants",
      preferredStructure: "Education, experience, publications, patents, skills",
      dislikes: ["Creative highlights", "Icons", "Summary paragraphs exceeding 4 lines", "No citation index details"]
    },
    strategy: {
      goal: "Pass academic and corporate R&D screeners and project extensive research credentials",
      focus: "Peer-reviewed publications, patent filing details, h-index, research grants",
      avoid: ["Gimmicky design elements", "Sidebar structures"]
    },
    psychology: {
      coreTraits: ["Academic excellence", "Methodological rigor", "Intellectual depth", "Scientific credibility"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Focus on research methodologies, experimental results, and publications. Use formal academic vocabulary.",
      rewriteStyle: "Formal, academic, scientific"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.4,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: true,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['education', 'experience', 'projects', 'skills', 'certifications']
      },
      overrides: {
        '--font-family-primary': 'Georgia, serif',
        '--spacing-margin': '24px'
      }
    }
  },
  sectionOrder: ['personal-info', 'education', 'experience', 'projects', 'skills', 'certifications'],
  components: {
    header: 'personal-info',
    main: ['education', 'experience', 'projects', 'skills', 'certifications'],
  },
  capabilities: {
    photo: false,
    icons: false,
    multiColumn: false,
    colorAccent: false,
    atsOptimized: true,
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.08em',
    '--heading-weight': '800',
    '--border-thickness-heading': '2.5px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '24px',
    '--spacing-item-mb': '14px',
    '--spacing-bullet-gap': '6px'
  }
};
export default researchCV;
